import { IInternationalText } from "@license-manager/types";


export const TextHelpers = {
  getLocalizedText(item: IInternationalText, language: string, fallbackLanguage = 'EN'): string {
    if (!item?.texts) return '';

    const primaryText = item.texts.find(t => t.language.toUpperCase() === language.toUpperCase())?.text;
    if (primaryText) return primaryText;

    const fallbackText = item.texts.find(t => t.language.toUpperCase() === fallbackLanguage)?.text;
    return fallbackText || '';
  }
};

export default TextHelpers;
